module.exports=[{
		"link": "/dataset",
		"name": [{
			"@language": "en",
			"@value": "Dataset catalogue"
		}, {
			"@language": "no",
			"@value": "Datasett"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/dataset.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/dataset.png"
		}],
		"screenshots": ["/assets/img/screenshots/dataset_esri.png"],
		"description": [{
			"@language": "no",
			"@value": "Alle publiserte og ikke-publiserte datasett som forvaltes av Norsk Polarinstitutt"
		}, {
			"@language": "en",
			"@value": "All published and non-published datasets curated by the Norwegian Polar Institute"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "//api.npolar.no",
		"name": [{
			"@language": "en",
			"@value": "REST APIs"
		}, {
			"@language": "no",
			"@value": "REST API"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/api.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/api.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Machine readable data"
		}, {
			"@language": "no",
			"@value": "Maskinlesbare data"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/map",
		"name": [{
			"@language": "en",
			"@value": "Maps"
		}, {
			"@language": "nb",
			"@value": "Kart"
		}, {
			"@language": "nn",
			"@value": "Kart"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/geodata.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/geodata.png"
		}],
		"screenshots": ["https://raw.githubusercontent.com/npolar/npdc-map/master/screenshots/Kartarkiv-framside-2016-02-08.png"],
		"description": [{
			"@language": "en",
			"@value": "Map data. Map services. Digitised maps. Web maps"
		}, {
			"@language": "nb",
			"@value": "Kartdata. Karttjenester. Kartasamlinga. Kart på web"
		}, {
			"@language": "nn",
			"@value": "Kartdata. Karttenestar. Kartsamlinga. Kart på web"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/expedition",
		"name": [{
			"@language": "en",
			"@value": "Expeditions"
		}, {
			"@language": "no",
			"@value": "Ekspedisjoner"
		}],
		"icons": [{
			"size": 96,
			"src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAKIElEQVR4Xu1dTW4byRX+XlMORiSC2CewdILYuyCxECmzSqhgpBOMHCmbbMw5wdAniLTJJmIsn8ASIiKriWjICbKz5gSWTjASAlGDmOQLqrtJNZvdXa+qq9kU0L0U6/d976/ee1UiVF+pFKBSZ68mRwVAyUxQAVABUDIFSp6+koAKAHsK8C/xTPWmf+PCfpRyez5oCeA1HPkAnGOnXDLaz/5gAeB1PMYQP/hbr+EJ9XBtT4byej5cAF6gDcK3PukYr+kD2uWR0X7mhwvAGj4BWAm3fknnWLUnQ3k9HyQAvIYtAO9iZNumcxyXR0q7mRcegJ1/3K0c/Xb5Mro9foEzENantszo0QdsRP+W1NeOTMX1WjgAFNFqI/4KwDqY14lwcNhsTPQ7/wIreOSrn9nvM1bpP5iAtde9bTPjFYh6AHrD+vLbow1aKGO9MADsnt59DeItgq9eJt/Ao9WoBISu59cpPPk26pIqMJdGPAUWA8dgOu5sLr8tjq/lI5cKwM4ZP17q//iKwTt0b1Anq2fmt53NxsTHD11PRdDHKVu8Rg2rUZd09/T2iIhmAGPgkkBHg/oXB2VKRWkA7Hb7r8DcJqI0YgIj2jj8/bJSH4G3ueYfuN5o+OslnQcHNPXt/f1uHR6fpfVh5mvAa5UlEXMHQBGEPX6TxPFThpb5+85mww81RACIup5pNJ1xSXdPby+I6OdZwPkSMaKXUcDlisS+5dwA8NXN7d23ILQkyx2BXv6tuTzhZH6BdRBSOXlqTMYGfcBEcv7QvdvxwDrJCcUM+4PG8ut5qaW5ABAYw9E7gKY4Oh0IvhnU6ytRIvCa7+Mr70jyndD5vTEPbE3/EqCfSToDfDHwvO24+yvra9aqcAB8lUOjd5m6PrZmBg46zfpEUjJdz7T9xlzS3W5/n4BXUvIo20DsbRetkgoFwEj0I5SZcT2jcR8xBafjQ0kuqWSouCqU9DFpUxgAdsTnGzC1Dzfr+zHjq6Ke6d5S8o6v6RxPoj/tnfZbIG7LVVHQu0gQCgHAhvhK7Qzry+248RO6nmlMN+WSqkbKHtT6d20TdVQkCM4B+GP3f88Yg48GYvh+4NFOmsHjF/gICjJfxh/jgj7geVK/UCUpL+vXknGVTfDo0cZfmz9xmn1zCoAfxxmOPsoNLr+OxnnihPBTjjWYgDlLyyGeZ6UsVbwIoCCvoPkUCMOa99yld+QUgL3u7UeZq8k3hEfrOm7SxH109Br/PhUfSuoUnJZHxzLbwBeHzUaiVEkXFG3nDAC5myckfjTlaLOzaB9ByjJQnZ97EhDibnKe5TkBQBdvGS+QgSsPS1s6zlft2cb1TKOEMGVpAkI8TmULghsARKpn9nSbtWieTjna7m/cT5yyDE/tF3pJcKOKcgMgNmKxyKaG+Ekpx7wgiFOWUol2cT7IBYDvU9/2P2m9HsY38cNVJgBJKce85E9IWWYNKWEs3ytq1FfzBO5yASBZJICTw2Z9KsuVSfyslGNeEGLxId1we92+iqhqzgnZrrRujlwA7J7e/qDj/nhcR7cgR65n2jRalzTaURI/UnmETrNuXRJjDYAs3GDGHYKU4z19GFeT3AJjH4SnOnABzKQsdX0k7nUeW2ANwN5pf7Y0ZGo3Zl6P73rKUo6qEu4AS2iPc78+cAO/Uk4Sbp6JD2WBIMolMHqHm/WpkhgdsOPfrQCQiCZgxv0hANkpR8b3GGEnLbTghy48HIGQlX4Uu6RjIkls3aC+/MTGGFsBIFE/xro/O+V4gxHa9C9MhalTz12/QgueXyuanAGLpSx13CphOFs1ZAXAXrevSw8aeT4h96eNeYLPaEULrnQE88cLvCkFWFIacyplKRlP4BEZ71nNawsAZy3alBsSU46hkc1b7+nXkSYZaUOXVCf16kzQ2WxMJYAkwBoDIIn3m+rDmbhPzMhKNpJ5tkgy0sL40HjcwBjfBfcRUj7C0nNJnCva3RiAIK2HP6fq34R6Hh0Bec2/aPEYGiOrG0f3e8xIz6Qsdf13u/1LQrq7ayr5VipI5xHEywl1mwpdz30TI6sbU/c73xvpVrSKTtcvrczxvp+552cuAZrjuSkX+OpngCNTI6sjlu533+4sYcfkZo3ODgB4f9isT5fNaxaSCsDqX/6baWh1G4z//ulPPzUG23QOl+3ntf8KgBTUKgBcsrPFWBUAFkRz2aUCwCU1LcaqALAgmssuFQAuqWkxVgWABdFcdikdgLTN6KKCpgcxl0QreixdGMY0/11MKCJ2uaJoosxzfH16cg6hCP1x3E3B0jwJK51LV/tqI/3G4YEiwtFSApTZbmHC0YoIe93b66zSPSbe7vyu8eAezsgCWCD5N4fNhuktHuuMmPOUZJncLZm7iDSslRH2JUCTlFFtTLNiEiKU1UaifmBYfjnei7ENUB0lVQI2ZSllEVg3ry4JlYfhrAAI7EB2ZYSLwlUdYebxu7AA2aoiwloFqY56o6RamfvF8yCqyRwS7rdxP3OpoHFnXZK6iEttJsTL21Zy6VDd+uk06+O364yntFZBoTuqvWGoHkjqNOvbxitbgA76+lf/xUajuw/xbeUCQFS46muifIssAwuJpweYFyA7BUDqkgbGxrxoqQzCqzklp31/bQ4YK5cETGyB5EGkAi45FwGQIv6IP5/pLp6wRQFa0nqdACC91Oa/w1Ovb9iUcRdB7PiYoUo9E102N7h0mLV2JwCoCfSh2vEy+ILw6KVpDWXRAIR3hN9IiL9wF7VNVJGvOgt6+MIWJKnaCdc+85ad7byBbXT4yS85B5My0Oo06wcmS9ClCk0r8NTrjQTZxQ/f6/G8Zwv7WMe9ByF7cyEE4Xjo0TfSTbkCwGeWIb+ZeQI5lRtkb1yYMJNzCRhPLgtT3C/Vf5+NvH3JI6p5AZg8Fsujls7TiRIzT7hhLkY4PokpCGPboAPCFgBbwqt1FUX8wiRgWhJG+/qHL2Z5ZPzG87DxxUnUbTUBIIhk/vhV0pvUMlXBNyN4rej7pbJ+8lZOjXDStEZPwKTr3wsw9Zhw+c+rYeZNyd88rbWIsQLidYlLmU6qYnR+fL7CAVAThlHFY93zwRK++e5qmNnsy6c1yTCZbdQpd1jztqSOQZ4J5wLAeIHyw1r6looGwOUhSwLMXAFQCwpf0t23lYaiAFBcT+y1in4ptxQVlMQJto+ougcg+bFYCfe6aDN3CYguOgx+tRik/oGD5LUTuAJAZbKI/ZfSj8oMDpYKQBSM8NygHnbKfCHdAQAnI9Bxka6liWQsDADjRYchgq0gROC7klMPbpgDwDcA9cDolc3tScAsHADxRapzxBDDZx5GKwCtf3c1zHxC7MuntfcA90bwLmuoXSxa2HthjLCJmEbbmpyEbeeYZ7+Fl4A4MSoA5skeCXNVAFQAOKVApYKcktN8sAoAc5o57fHgAHC6+wUYrAKgZBAqACoASqZAydNXElABUDIFSp7+/58UN6xCez4sAAAAAElFTkSuQmCC"
		}, {
			"size": 48,
			"src": "data:image/png;base64,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"
		}],
		"screenshots": ["/assets/img/screenshots/expedition.png"],
		"description": [{
			"@language": "en",
			"@value": "Cruises and field campaigns"
		}, {
			"@language": "no",
			"@value": "Tokt og felt"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/geology",
		"name": [{
			"@language": "en",
			"@value": "Geology"
		}, {
			"@language": "no",
			"@value": "Geologi"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/geology.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/geology.png"
		}],
		"screenshots": ["/assets/img/screenshots/geology.png"],
		"description": [{
			"@language": "en",
			"@value": "Geology rock collection"
		}, {
			"@language": "no",
			"@value": "Geologi steinsamling"
		}],
		"category": "public",
		"promote": true
	},

	{
		"link": "/tracking",
		"name": [{
			"@language": "en",
			"@value": "Tracking"
		}, {
			"@language": "no",
			"@value": "Sporing"
		}],
		"icons": [{
			"size": 96,
			"src": "https://openclipart.org/image/96px/svg_to_png/205608/gps-icon.png"
		}, {
			"size": 48,
			"src": "https://openclipart.org/image/96px/svg_to_png/205608/gps-icon.png"
		}],
		"screenshots": ["/assets/img/screenshots/tracking.png"],
		"description": [{
			"@language": "en",
			"@value": "Animal positions and sensor data"
		}, {
			"@language": "no",
			"@value": "Sporing av dyr: posisjoner og sensordata"
		}],
		"category": "internal",
		"promote": false
	}, {
		"link": "/vessel",
		"name": [{
			"@language": "en",
			"@value": "Vessels"
		}, {
			"@language": "no",
			"@value": "Skuter"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/vessels.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/vessels.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "The life history of ships sailing in the Arctic, built before 1940"
		}, {
			"@language": "nb",
			"@value": "Historien til arktiske skuter bygget før 1940"
		}, {
			"@language": "nn",
			"@value": "Historia til arktiske skuter bygd før 1940"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/person",
		"name": [{
			"@language": "en",
			"@value": "People"
		}, {
			"@language": "no",
			"@value": "Personer"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/people.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/people.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Browse employees at the institue"
		}, {
			"@language": "no",
			"@value": "Ansatte ved Norsk Polarinstitutt"
		}],
		"category": "public",
		"promote": true
	},

	{
		"link": "http://svalbardkartet.npolar.no",
		"name": [{
			"@language": "en",
			"@value": "Svalbard atlas"
		}, {
			"@language": "nb",
			"@value": "Svalbard-kartet"
		}, {
			"@language": "nn",
			"@value": "Svalbard-kartet"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/svalbardkartet-logo.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/svalbardkartet-logo.png"
		}],
		"screenshots": ["/assets/img/screenshots/svalbardkartet.png"],
		"description": [{
			"@language": "en",
			"@value": "Interactive thematic atlas over Svalbard"
		}, {
			"@language": "nb",
			"@value": "Interaktivt temaatlas over Svalbard"
		}, {
			"@language": "nn",
			"@value": "Interaktivt temaatlas over Svalbard"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "https://placenames.npolar.no/",
		"name": [{
			"@language": "en",
			"@value": "Placenames"
		}, {
			"@language": "nb",
			"@value": "Stedsnavn"
		}, {
			"@language": "nn",
			"@value": "Stadnamn"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/placename.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/placename.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Official place names in Norwegian polar regions"
		}, {
			"@language": "nb",
			"@value": "Offisielle stedsnavn i norske polarområder"
		}, {
			"@language": "nn",
			"@value": "Offisielle stadnamn i norske polarområde"
		}],
		"category": "public",
		"promote": true
	},

	{
		"link": "/indicator/timeseries",
		"name": [{
			"@language": "en",
			"@value": "Timeseries"
		}, {
			"@language": "no",
			"@value": "Tidsserier"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/timeseries.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/timeseries.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Long-term environmental monitoring"
		}, {
			"@language": "no",
			"@value": "Langsiktig miljøovervåking"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/course",
		"name": [{
			"@language": "en",
			"@value": "Course"
		}, {
			"@language": "no",
			"@value": "Kurs"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/courses.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/courses.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Courses available at the institute"
		}, {
			"@language": "no",
			"@value": "Kurs tilgjengelig ved instituttet"
		}],
		"category": "internal"
	}, {
		"link": "/inventory",
		"name": [{
			"@language": "en",
			"@value": "Inventory"
		}, {
			"@language": "no",
			"@value": "Aktivitet"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/inventory.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/inventory.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "no",
			"@value": "Tidligere aktivitet Antarktis"
		}, {
			"@language": "en",
			"@value": "Inventory of past activities Antarctica"
		}],
		"category": "internal",
		"promote": true
	}, {
		"link": "/ecotox",
		"name": [{
			"@language": "en",
			"@value": "Ecotox"
		}, {
			"@language": "no",
			"@value": "Økotoks"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/ecotox.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/ecotox.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "no",
			"@value": "Økotoks felt database"
		}, {
			"@language": "en",
			"@value": "Ecotox field database"
		}],
		"category": "internal",
		"promote": true
	},
	 {
		"link": "/station-booking",
		"name": [{
			"@language": "en",
			"@value": "Stations"
		}, {
			"@language": "no",
			"@value": "Stasjoner"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/station-booking.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/station-booking.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "no",
			"@value": "Forskningsstasjoner Statistikk"
		}, {
			"@language": "en",
			"@value": "Research Stations Statistics"
		}],
		"category": "internal",
		"promote": true
	},

	{
		"link": "/marine/biology",
		"name": [{
			"@language": "en",
			"@value": "Marine Biology"
		}, {
			"@language": "no",
			"@value": "Marinbiologi"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/marine_biology.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/marine_biology.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Sample database for nutrients, lipids and plankton"
		}, {
			"@language": "no",
			"@value": "Database for næringsstoffer, lipider og plankton"
		}],
		"category": "disabled"
	}, {
		"link": "/user",
		"name": [{
			"@language": "en",
			"@value": "Users"
		}, {
			"@language": "nb",
			"@value": "Brukere"
		}, {
			"@language": "nn",
			"@value": "Brukarar"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/users.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/users.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "User administration"
		}, {
			"@language": "no",
			"@value": "Brukeradministrasjon"
		}],
		"category": "internal"
	}, {
		"link": "/publication",
		"name": [{
			"@language": "en",
			"@value": "Publications"
		}, {
			"@language": "no",
			"@value": "Publikasjoner"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/publication.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/publication.png"
		}],
		"screenshots": ["/assets/img/screenshots/publication.png"],
		"description": [{
			"@language": "en",
			"@value": "Scientific articles and other publications by Norwegian Polar Institute staff"
		}, {
			"@language": "no",
			"@value": "Vitenskapelige artikler og andre publikasjoner som er produsert av ansatte ved Norsk Polarinstitutt"
		}],
		"category": "public",
		"promote": false
	}, {
		"link": "/project",
		"name": [{
			"@language": "en",
			"@value": "Projects"
		}, {
			"@language": "no",
			"@value": "Prosjekter"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/service.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/service.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Project catalogue"
		}, {
			"@language": "no",
			"@value": "Prosjektkatalog"
		}],
		"category": "public"
	}, {
		"link": "/text",
		"name": [{
			"@language": "en",
			"@value": "Texts"
		}, {
			"@language": "nb",
			"@value": "Tekster"
		}, {
			"@language": "nn",
			"@value": "Tekstar"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/text.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/text.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "i18n texts"
		}],
		"category": "internal"
	}, {
		"link": "/sighting",
		"name": [{
			"@language": "en",
			"@value": "MMS"
		}, {
			"@language": "no",
			"@value": "Observasjoner"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/sighting.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/sighting.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "no",
			"@value": "Observasjoner av marine pattedyr på Svalbard"
		}, {
			"@language": "en",
			"@value": "Svalbard Marine Mammal Sightings"
		}],
		"category": "public",
		"promote": true
	},

{
		"link": "/seabird-colony",
		"name": [{
			"@language": "en",
			"@value": "Seabird colonies"
		}, {
			"@language": "no",
			"@value": "Sjøfugl kolonier"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/seabird-colony.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/seabird-colony.png"
		}],
		"screenshots": ["/assets/img/screenshots/seabird-colony.png"],
		"description": [{
			"@language": "en",
			"@value": "Seabird colonies Svalbard"
		}, {
			"@language": "no",
			"@value": "Sjøfuglkolonier Svalbard"
		}],
		"category": "public",
		"promote": true
	},
  {
  		"link": "/mapview",
  		"name": [{
  			"@language": "en",
  			"@value": "Mapview"
  		}, {
  			"@language": "no",
  			"@value": "Kartoversikt"
  		}],
  		"icons": [{
  			"size": 96,
  			"src": "/assets/img/app-icons/96/mapview.png"
  		}, {
  			"size": 48,
  			"src": "/assets/img/app-icons/48/mapview.png"
  		}],
  		"screenshots": ["/assets/img/screenshots/mapview.png"],
  		"description": [{
  			"@language": "en",
  			"@value": "Mapview NPI databases"
  		}, {
  			"@language": "no",
  			"@value": "Kartoversikt NP databaser"
  		}],
  		"category": "public",
  		"promote": true
  	},

{
		"link": "/pbhims",
		"name": [{
		    "@language": "en",
		    "@value": "PBHIMS"
		}, {
		    "@language": "no",
		    "@value": "PBHIMS"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/pbhims.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/pbhims.png"
		}],
		"screenshots": [],
		"description": [{
		    "@language": "en",
		    "@value": "Polar Bear/Human Information Management System"
		}, {
		    "@language": "no",
		    "@value": "Hendelsesregister for interaksjoner mellom isbjørn og mennesker"
		}],
                "category": "public",
                "promote": true
	}
]
